import React, { } from "react";
import styled from "styled-components";
import { DebouncedProgress, IndeterminateProgress } from "--floponents-web/atoms/Progress";

const Loading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
`;

export const CemStatusDialogBodyLoading = () => {
    return <Loading>
        <DebouncedProgress showAfter={500}>
            <IndeterminateProgress />
        </DebouncedProgress>
    </Loading>
}

